export const AVATARS = [
  ['disco', 'Disco'], ['lime', 'Lime'], ['cherries', 'Cherries'],
  ['ghost', 'Party ghost'], ['tiger', 'Tiger'], ['sardine', 'Fancy fish'],
  ['cactus', 'Cowboy cactus'], ['mushroom', 'Daydreamer'], ['duck', 'Duck'],
].map(([id, name], index) => ({ id, name, x: (index % 3) * 50, y: Math.floor(index / 3) * 50 }));

export function isPlayerPhoto(value) {
  if (typeof value !== 'string' || value.length > 16000 || !value.startsWith('data:image/jpeg;base64,/9j/') || !/^[A-Za-z0-9+/]*={0,2}$/.test(value.slice(23))) return false;
  try {
    const bytes = atob(value.slice(23));
    if (bytes.length < 12 || bytes.charCodeAt(bytes.length - 2) !== 255 || bytes.charCodeAt(bytes.length - 1) !== 217) return false;
    let offset = 2;
    while (offset + 8 < bytes.length) {
      if (bytes.charCodeAt(offset++) !== 255) return false;
      while (bytes.charCodeAt(offset) === 255) offset++;
      const marker = bytes.charCodeAt(offset++);
      if (marker === 218 || marker === 217) return false;
      const size = bytes.charCodeAt(offset) * 256 + bytes.charCodeAt(offset + 1);
      if (size < 2 || offset + size > bytes.length) return false;
      if ([192,193,194].includes(marker)) {
        const height = bytes.charCodeAt(offset + 3) * 256 + bytes.charCodeAt(offset + 4);
        const width = bytes.charCodeAt(offset + 5) * 256 + bytes.charCodeAt(offset + 6);
        return size >= 8 && width > 0 && height > 0 && width <= 160 && height <= 160;
      }
      offset += size;
    }
  } catch {}
  return false;
}

export const MAX_PHOTO_LENGTH = 16000;
export function cleanIdentity(value = {}) {
  const identity = {};
  if (AVATARS.some(a => a.id === value?.avatarId)) identity.avatarId = value.avatarId;
  if (isPlayerPhoto(value?.photoDataUrl)) identity.photoDataUrl = value.photoDataUrl;
  return identity;
}
export function defaultAvatar(seed = '') {
  const id = String(seed);
  const number = /^player\d+$/.test(id) ? Number(id.slice(6)) - 1 : [...id].reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  return AVATARS[Math.abs(number) % AVATARS.length];
}
export function identityFor(player = {}) {
  return { avatarId: defaultAvatar(player.playerId || player.id || player.name).id, ...cleanIdentity(player) };
}

export function validatePhotoFile(file) {
  if (!file || (file.type ? !/^image\/(jpeg|png|webp|heic|heif|avif)$/.test(file.type) : !/\.(jpe?g|png|webp|heic|heif|avif)$/i.test(file.name))) throw new Error('Choose a JPG, PNG, WebP, or a photo from your camera.');
  if (file.size > 20 * 1024 * 1024) throw new Error('Choose a photo smaller than 20 MB.');
}
export function cropPhoto(image, { zoom = 1, x = .5, y = .5 } = {}) {
  const side = Math.min(image.naturalWidth, image.naturalHeight) / zoom;
  const canvas = document.createElement('canvas'); canvas.width = 160; canvas.height = 160;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('This browser could not prepare the photo. Try choosing another photo.');
  ctx.fillStyle = '#fff9ef'; ctx.fillRect(0, 0, 160, 160);
  ctx.drawImage(image, (image.naturalWidth - side) * x, (image.naturalHeight - side) * y, side, side, 0, 0, 160, 160);
  for (const quality of [.8, .65, .5, .35]) {
    const photo = canvas.toDataURL('image/jpeg', quality);
    if (cleanIdentity({ photoDataUrl: photo }).photoDataUrl) return photo;
  }
  throw new Error('This photo could not be resized. Try another photo.');
}
